const config = {
  authRealm: process.env.uvote,
  authUrl: process.env.https://authuvote.prod.cineca.it/auth,
  authClientId: process.env.uvote-ceo,
  credentials: {
    secret: process.env.6dfO2bibo0ckt2vo4jhMzyGjbbyxi4bk
  },

  logoutRedirectUri: process.env.https://uvote.cineca.it/
};

export default config;
